import React from "react";  
import CardContainer from "./CardContainer";
import Button from "./Button";
import LogoSection from "./LogoSection";

const AiResult = ({handleNavigateClick,styles}) => {

     const logos = [
    { src: '/images/logos/heavenMayhemLogo.webp', alt: 'Heaven Mayhem' },
    { src: '/images/logos/liquidIvLogo.webp', alt: 'Liquid IV logo', height: '40px' },
    { src: '/images/logos/neuroLogo.webp', alt: 'Marcha Logo' },
    { src: '/images/logos/trulyLogo.webp', alt: 'Truly Beauty Logo' },
    { src: '/images/logos/faytLogo.webp', alt: 'Fayt the label logo', height: '50px' },
    { src: '/images/logos/maskLogo.webp', alt: 'Mask Logo' },
    { src: '/images/logos/aclerLogo.webp', alt: 'Acler Logo' },
    { src: '/images/logos/july.webp', alt: 'July logo', height: '40px' },
  ];

  return (
   <section className={`${styles.container} ${styles.resultSection}`}>
          <div className={styles.headingContainer}>
            <h1 className={styles.sectionTitle}>Real results from real customers</h1>
            <p className={styles.sectionSubTitle}>See how fast-growing brands are winning with Instant AI</p>
          </div>
          <ul className={styles.cardContainer}>
            <li className='half-width'>
              <CardContainer className={styles.aiResultCard} onClick={()=>handleNavigateClick('https://www.instant.one/case-studies/karen-kane-s-secret-to-recovering-707k-from-existing-traffic-in-60-days')}>
                <div className={styles.textContainer}>
                  <h2 className={styles.cardHeading}>Karen Kane</h2>
                  <p className={styles.cardDesc}>The How Karen Kane increased revenue by <span className={styles.greenHighlight}>$707k</span> in 60 days with Instant AI</p>
                </div>
                
                <img src="/images/logos/karenKaneLogo.webp" alt="Collagen logo" className={styles.brandLogoImage} />
              </CardContainer>
            </li>

            <li className='half-width'>
              <CardContainer className={styles.aiResultCard} onClick={()=>handleNavigateClick('https://www.instant.one/case-studies/how-mercha-grew-retention-revenue-13-in-30-days-with-instant-ai-audiences')}>
                <div className={styles.textContainer}>
                  <h2 className={styles.cardHeading}>Mercha</h2>
                  <p className={styles.cardDesc}>How Mercha Boosted Conversion Revenue <span className={styles.greenHighlight}>7x</span> in 12 Days with Instant AI</p>
                </div>
                <img src="/images/logos/merchaLogo.webp" alt="Mercha logo" className={styles.brandLogoImage} />
              </CardContainer>
            </li>

            <li className='half-width'>
              <CardContainer className={styles.aiResultCard} onClick={()=>handleNavigateClick('https://www.instant.one/case-studies')}>
                <div className={styles.textContainer}>
                  <h2 className={styles.cardHeading}>GolfBox</h2>
                  <p className={styles.cardDesc}>How GolfBox Increased Revenue By <span className={styles.greenHighlight}>$230k</span> with AI-driven flows</p>
                </div>
                <img src="/images/logos/golfBoxLogo.webp" alt="GolfBox logo" className={styles.brandLogoImage} />
              </CardContainer>
            </li>
          </ul>
          <div className={styles.logoSectionContainer}>
            <LogoSection logos={logos}/>
          </div>

          <div className={styles.centerCtaContainer}>
            <Button onClick={()=>handleNavigateClick('https://www.instant.one/case-studies')}>View all success stories</Button>
          </div>

        </section>
  );
}   

export default AiResult;
